var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaceMatch(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 281,
    height: 314,
    viewBox: "0 0 281 314",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.8173 104.275L142.353 73.3657C145.175 71.7384 149.355 65.4803 149.355 61.7238V59.4387C149.355 55.6821 147.07 53.9596 144.257 55.5869L88.8605 88.392C86.0474 90.0193 83.7623 94.3818 83.7623 98.1384V100.415C83.719 104.171 86.0042 105.894 88.8173 104.275Z",
    fill: "#00ABAB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M136.7 68.4897C136.7 67.8665 136.259 67.6241 135.713 67.9184C135.424 68.1084 135.183 68.3643 135.012 68.6652C134.84 68.9662 134.742 69.3035 134.727 69.6495C134.727 70.2814 135.168 70.5151 135.713 70.2208C136.003 70.0309 136.243 69.7749 136.415 69.474C136.587 69.173 136.684 68.8357 136.7 68.4897Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M130.91 71.8352C130.91 71.212 130.469 70.9696 129.923 71.2726C129.633 71.4614 129.393 71.7173 129.223 72.0186C129.053 72.3199 128.957 72.6578 128.945 73.0037C128.945 73.6356 129.378 73.8693 129.923 73.575C130.214 73.3842 130.455 73.1269 130.627 72.8243C130.799 72.5218 130.896 72.1827 130.91 71.8352Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M125.121 75.1826C125.121 74.5508 124.68 74.317 124.143 74.6113C123.852 74.7997 123.61 75.0553 123.439 75.3566C123.267 75.6579 123.17 75.996 123.156 76.3425C123.156 76.9744 123.598 77.2081 124.143 76.9138C124.431 76.7229 124.67 76.4665 124.84 76.1656C125.01 75.8647 125.106 75.5279 125.121 75.1826Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M119.337 78.5254C119.337 77.8935 118.895 77.6598 118.35 77.9541C118.06 78.1435 117.819 78.3994 117.647 78.7004C117.476 79.0015 117.378 79.3391 117.363 79.6853C117.363 80.3171 117.805 80.5508 118.35 80.2565C118.64 80.0671 118.881 79.8113 119.053 79.5102C119.224 79.2092 119.322 78.8716 119.337 78.5254Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M113.548 81.8633C113.548 81.2314 113.106 80.9977 112.561 81.292C112.271 81.4814 112.03 81.7373 111.858 82.0383C111.687 82.3394 111.589 82.677 111.574 83.0231C111.574 83.6464 112.016 83.8887 112.561 83.5858C112.851 83.3982 113.092 83.144 113.264 82.8444C113.435 82.5447 113.533 82.2083 113.548 81.8633Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M107.755 85.2344C107.755 84.6025 107.313 84.3688 106.768 84.6631C106.478 84.853 106.238 85.109 106.066 85.4099C105.895 85.7109 105.797 86.0482 105.781 86.3942C105.781 87.0175 106.223 87.2598 106.768 86.9655C107.058 86.7756 107.298 86.5196 107.47 86.2187C107.641 85.9177 107.739 85.5804 107.755 85.2344Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M101.974 88.5473C101.974 87.9241 101.532 87.6817 100.987 87.976C100.697 88.166 100.457 88.4219 100.285 88.7229C100.114 89.0238 100.016 89.3611 100 89.7072C100 90.339 100.441 90.5727 100.987 90.2784C101.276 90.0885 101.517 89.8325 101.688 89.5316C101.86 89.2307 101.958 88.8933 101.974 88.5473Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1727 91.887C96.1727 91.2637 95.7313 91.0214 95.186 91.3243C94.8948 91.5127 94.6532 91.7683 94.4815 92.0696C94.3098 92.3708 94.2129 92.709 94.1992 93.0555C94.1992 93.6873 94.6407 93.921 95.186 93.6268C95.4768 93.436 95.718 93.1786 95.8896 92.8761C96.0612 92.5735 96.1582 92.2345 96.1727 91.887Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M88.817 128.511L142.353 97.6018C145.174 95.9745 147.451 91.612 147.451 87.8641V85.579C147.451 81.8311 145.174 80.0999 142.353 81.7272L88.817 112.619C86.0039 114.247 83.7188 118.609 83.7188 122.366V124.642C83.7187 128.399 86.0039 130.121 88.817 128.511Z",
    fill: "#F2F2F2"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M136.7 93.0862C136.7 92.463 136.259 92.2206 135.713 92.5235C135.422 92.7119 135.181 92.9675 135.009 93.2688C134.837 93.5701 134.74 93.9082 134.727 94.2547C134.727 94.8866 135.168 95.1203 135.713 94.826C136.005 94.6357 136.246 94.3785 136.418 94.0758C136.59 93.7732 136.686 93.4339 136.7 93.0862Z",
    fill: "#49A39B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M130.91 96.4336C130.91 95.8017 130.469 95.568 129.923 95.8623C129.634 96.0522 129.395 96.3083 129.225 96.6094C129.055 96.9105 128.959 97.2479 128.945 97.5935C128.945 98.2253 129.378 98.459 129.923 98.1647C130.214 97.9753 130.454 97.7195 130.626 97.4184C130.798 97.1174 130.895 96.7798 130.91 96.4336Z",
    fill: "#49A39B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M125.121 99.7764C125.121 99.1445 124.68 98.9108 124.143 99.2051C123.853 99.3945 123.612 99.6504 123.44 99.9514C123.269 100.252 123.171 100.59 123.156 100.936C123.156 101.568 123.598 101.802 124.143 101.508C124.432 101.317 124.671 101.061 124.841 100.76C125.011 100.459 125.107 100.122 125.121 99.7764Z",
    fill: "#49A39B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M119.337 103.114C119.337 102.482 118.895 102.249 118.35 102.543C118.06 102.732 117.819 102.988 117.647 103.289C117.476 103.59 117.378 103.928 117.363 104.274C117.363 104.897 117.805 105.14 118.35 104.837C118.64 104.649 118.881 104.395 119.053 104.095C119.224 103.796 119.322 103.459 119.337 103.114Z",
    fill: "#49A39B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M113.548 106.457C113.548 105.825 113.106 105.591 112.561 105.886C112.271 106.076 112.031 106.332 111.859 106.633C111.688 106.934 111.59 107.271 111.574 107.617C111.574 108.24 112.016 108.482 112.561 108.188C112.851 107.998 113.091 107.742 113.263 107.441C113.434 107.14 113.532 106.803 113.548 106.457Z",
    fill: "#49A39B"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M107.755 109.798C107.755 109.175 107.313 108.933 106.768 109.227C106.478 109.417 106.238 109.673 106.066 109.974C105.895 110.275 105.797 110.612 105.781 110.958C105.781 111.59 106.223 111.824 106.768 111.529C107.058 111.339 107.298 111.084 107.47 110.783C107.641 110.482 107.739 110.144 107.755 109.798Z",
    fill: "#49A39B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M101.974 113.138C101.974 112.515 101.532 112.272 100.987 112.575C100.696 112.764 100.454 113.019 100.282 113.321C100.111 113.622 100.014 113.96 100 114.306C100 114.938 100.441 115.172 100.987 114.878C101.278 114.687 101.52 114.43 101.691 114.128C101.863 113.825 101.96 113.486 101.974 113.138Z",
    fill: "#49A39B"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M207.146 288.788L207.12 298.725L204.965 294.112L204.991 284.184L207.146 288.788Z",
    fill: "#D3E5E4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M260.858 299.473C261.184 299.144 261.576 298.887 262.009 298.72H267.047L269.159 294.107L267.254 293.813C266.632 293.725 266.031 293.526 265.48 293.224C265.176 293.089 264.916 292.871 264.73 292.596C264.543 292.32 264.437 291.998 264.424 291.666C264.472 291.055 264.472 290.442 264.424 289.831C264.424 288.515 265.999 287.866 267.22 287.676L269.124 287.381L266.977 282.777H261.94C261.774 282.707 261.612 282.629 261.455 282.543C261.206 282.403 260.979 282.228 260.78 282.024C260.28 281.463 259.748 280.931 259.187 280.431C258.019 279.297 258.858 278.267 259.75 277.748L261.135 276.943L255.292 273.576L253.907 274.381C253.201 274.752 252.426 274.973 251.631 275.03C250.835 275.086 250.036 274.977 249.285 274.709C248.419 274.381 247.467 274.069 246.533 273.792C246.217 273.694 245.912 273.563 245.624 273.402C244.507 272.753 244.447 271.888 244.706 271.308L245.217 270.208L237.245 268.971L236.743 270.07C236.423 270.788 235.315 271.723 233.047 271.706C231.982 271.706 230.926 271.706 229.87 271.706C228.932 271.748 228 271.539 227.17 271.1C226.736 270.868 226.38 270.513 226.148 270.079L225.638 268.971L217.64 270.208L218.159 271.308C218.488 272.018 218.341 273.151 216.367 273.792C215.433 274.069 214.515 274.381 213.624 274.718C212.871 274.983 212.073 275.09 211.277 275.032C210.482 274.974 209.707 274.752 209.001 274.381L207.599 273.576L201.791 276.943L203.185 277.756C204.05 278.267 204.916 279.297 203.782 280.431C203.227 280.931 202.701 281.463 202.207 282.024C201.099 283.166 199.151 283.261 197.922 283.071L196.018 282.777L193.914 287.381L195.81 287.676C196.431 287.766 197.032 287.966 197.584 288.264C197.888 288.403 198.147 288.622 198.333 288.899C198.52 289.175 198.626 289.498 198.64 289.831C198.593 290.442 198.593 291.055 198.64 291.666C198.643 291.89 198.598 292.112 198.507 292.317C198.415 292.522 198.281 292.704 198.112 292.852H185.129V298.72H201.194C201.355 298.785 201.511 298.86 201.661 298.945C201.911 299.091 202.141 299.269 202.345 299.473C202.85 300.032 203.385 300.564 203.946 301.066C204.136 301.248 204.291 301.462 204.405 301.698H196.866V307.921H208.274V307.679L209.218 307.125C209.924 306.751 210.701 306.528 211.498 306.47C212.295 306.412 213.095 306.52 213.849 306.788L214.905 307.16V312.526H225.863L226.365 311.427C226.406 311.344 226.452 311.263 226.503 311.185V312.526H237.479L245.425 311.297L244.914 310.189C244.611 309.557 244.706 308.588 246.143 307.93H255.465L261.273 304.554L259.88 303.749C259.014 303.23 258.149 302.2 259.282 301.075C259.838 300.572 260.364 300.037 260.858 299.473ZM242.153 296.877C236.31 300.278 226.789 300.278 220.903 296.877C215.017 293.475 214.982 287.961 220.834 284.56C226.685 281.158 236.198 281.167 242.084 284.56C247.969 287.953 248.004 293.475 242.153 296.868V296.877Z",
    fill: "url(#paint0_linear_3195_2978)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M231.047 274.705C225.204 271.329 215.752 271.329 209.944 274.705C204.751 277.708 204.232 282.374 208.3 285.749C208.818 285.327 209.368 284.945 209.944 284.607C215.752 281.231 225.204 281.231 231.047 284.607C231.656 284.953 232.235 285.35 232.778 285.793C236.846 282.417 236.275 277.725 231.047 274.705Z",
    fill: "url(#paint1_linear_3195_2978)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M233.747 261.375C233.663 261.56 233.619 261.76 233.617 261.963V271.9C233.619 271.697 233.663 271.496 233.747 271.311L234.249 270.212V260.275L233.747 261.375Z",
    fill: "url(#paint2_linear_3195_2978)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M207.253 261.375L206.742 260.275V270.212L207.253 271.329C207.344 271.521 207.392 271.731 207.391 271.943V262.007C207.393 261.788 207.346 261.572 207.253 261.375Z",
    fill: "url(#paint3_linear_3195_2978)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M248.798 267.862C248.496 268.002 248.235 268.216 248.037 268.484C247.839 268.751 247.711 269.064 247.664 269.394V279.33C247.708 278.999 247.836 278.684 248.034 278.415C248.232 278.146 248.495 277.931 248.798 277.79L250.183 276.985V267.057L248.798 267.862Z",
    fill: "url(#paint4_linear_3195_2978)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M192.269 267.862L190.875 267.057V276.985L192.269 277.798C192.577 277.939 192.845 278.155 193.046 278.428C193.248 278.701 193.376 279.02 193.42 279.356V269.42C193.378 269.083 193.25 268.763 193.049 268.49C192.847 268.217 192.578 268 192.269 267.862Z",
    fill: "#DBEDEB"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M256.268 277.741C255.057 277.931 253.473 278.563 253.473 279.844V289.781C253.473 288.5 255.057 287.868 256.268 287.677L258.173 287.383V277.446L256.268 277.741Z",
    fill: "url(#paint5_linear_3195_2978)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M253.508 280.891V290.827C253.508 291.104 253.508 291.39 253.508 291.693V281.756C253.499 281.453 253.508 281.168 253.508 280.891Z",
    fill: "#242D3C"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M187.715 281.54V279.896C187.701 279.563 187.594 279.24 187.408 278.964C187.222 278.687 186.962 278.468 186.659 278.329C186.105 278.036 185.505 277.837 184.885 277.741L182.98 277.446V287.383L184.885 287.677C185.506 287.769 186.106 287.969 186.659 288.266C186.909 288.39 187.13 288.566 187.306 288.782C187.483 288.999 187.61 289.251 187.681 289.521V290.69C187.681 291.01 187.681 291.339 187.681 291.668V281.731C187.697 281.668 187.708 281.605 187.715 281.54Z",
    fill: "#DBEDEB"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M258.208 284.183L258.182 294.111L256.07 298.724L256.105 288.787L258.208 284.183Z",
    fill: "url(#paint6_linear_3195_2978)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M254.2 288.494C252.971 288.303 251.015 288.39 249.915 289.541C249.421 290.102 248.895 290.633 248.34 291.134C248.174 291.271 248.039 291.441 247.942 291.633C247.845 291.825 247.789 292.035 247.777 292.25V302.187C247.789 301.973 247.844 301.764 247.939 301.572C248.034 301.38 248.168 301.209 248.331 301.07C248.889 300.57 249.418 300.038 249.915 299.478C251.015 298.327 252.971 298.24 254.191 298.43L256.095 298.725V288.788L254.2 288.494Z",
    fill: "url(#paint7_linear_3195_2978)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M192.978 291.131C192.414 290.63 191.88 290.099 191.376 289.538C191.179 289.332 190.951 289.156 190.701 289.019C189.583 288.461 188.315 288.276 187.083 288.491L185.188 288.785V298.722L187.083 298.427C188.314 298.214 189.58 298.396 190.701 298.947C190.948 299.093 191.175 299.27 191.376 299.475C191.882 300.033 192.416 300.565 192.978 301.067C193.145 301.207 193.282 301.38 193.38 301.575C193.479 301.77 193.536 301.983 193.549 302.201V292.264C193.538 292.046 193.482 291.832 193.383 291.637C193.285 291.442 193.147 291.269 192.978 291.131Z",
    fill: "url(#paint8_linear_3195_2978)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M250.33 294.611L250.295 304.548L244.496 307.924L244.522 297.987L250.33 294.611Z",
    fill: "url(#paint9_linear_3195_2978)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M196.872 297.987L196.847 307.924L191.004 304.548L191.03 294.611L196.872 297.987Z",
    fill: "#D3E5E4"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M243.12 297.182C242.415 296.811 241.639 296.59 240.844 296.533C240.048 296.476 239.25 296.586 238.498 296.854C237.633 297.182 236.689 297.485 235.754 297.771C234.283 298.247 233.824 298.991 233.824 299.641V309.577C233.824 308.928 234.283 308.184 235.754 307.708C236.689 307.422 237.607 307.119 238.498 306.782C239.25 306.515 240.049 306.407 240.845 306.465C241.64 306.524 242.415 306.746 243.12 307.119L244.523 307.924V297.987L243.12 297.182Z",
    fill: "url(#paint10_linear_3195_2978)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M206.543 298.161C206.256 297.998 205.951 297.868 205.635 297.772C204.7 297.486 203.782 297.183 202.882 296.846C202.13 296.578 201.331 296.47 200.535 296.528C199.74 296.586 198.965 296.809 198.26 297.183L196.875 297.988V307.925L198.26 307.12C198.965 306.746 199.74 306.523 200.535 306.465C201.331 306.407 202.13 306.515 202.882 306.782C203.748 307.12 204.691 307.423 205.635 307.7C205.936 307.803 206.226 307.936 206.5 308.098C206.797 308.225 207.052 308.433 207.238 308.697C207.423 308.962 207.53 309.273 207.547 309.596V299.667C207.535 299.348 207.435 299.039 207.258 298.773C207.081 298.507 206.833 298.295 206.543 298.161Z",
    fill: "url(#paint11_linear_3195_2978)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M234.484 301.354L234.459 311.29L226.504 312.519L226.53 302.583L234.484 301.354Z",
    fill: "url(#paint12_linear_3195_2978)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M226.019 301.483C225.787 301.049 225.431 300.694 224.997 300.462C224.164 300.022 223.229 299.813 222.288 299.856C221.241 299.856 220.176 299.856 219.12 299.856C216.852 299.856 215.744 300.774 215.424 301.483L214.922 302.583V312.519L215.424 311.42C215.753 310.71 216.861 309.776 219.129 309.793C220.185 309.793 221.249 309.793 222.297 309.793C223.236 309.752 224.17 309.958 225.006 310.39C225.439 310.625 225.791 310.983 226.019 311.42L226.538 312.519V302.583L226.019 301.483Z",
    fill: "url(#paint13_linear_3195_2978)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M248.938 293.833L250.331 294.638L244.523 298.014L243.121 297.209C242.415 296.837 241.64 296.616 240.845 296.56C240.049 296.503 239.25 296.612 238.499 296.88C237.633 297.209 236.69 297.512 235.755 297.797C233.782 298.438 233.635 299.572 233.963 300.282L234.483 301.381L226.528 302.61L226.018 301.511C225.786 301.077 225.43 300.721 224.996 300.489C224.163 300.05 223.228 299.841 222.287 299.883C221.24 299.883 220.175 299.883 219.119 299.883C216.851 299.883 215.743 300.801 215.423 301.511L214.921 302.61L206.949 301.381L207.46 300.273C207.719 299.693 207.659 298.836 206.542 298.187C206.255 298.024 205.95 297.893 205.633 297.797C204.698 297.512 203.781 297.209 202.881 296.871C202.129 296.604 201.33 296.495 200.534 296.554C199.738 296.612 198.963 296.835 198.259 297.209L196.874 298.014L191.031 294.638L192.416 293.833C193.282 293.314 194.147 292.292 192.979 291.158C192.415 290.658 191.881 290.127 191.377 289.566C191.178 289.359 190.951 289.182 190.702 289.038C189.581 288.487 188.315 288.305 187.084 288.518L185.189 288.813L183.016 284.182L184.912 283.888C186.141 283.689 187.751 283.022 187.707 281.732C187.66 281.122 187.66 280.508 187.707 279.897C187.693 279.564 187.586 279.242 187.4 278.965C187.214 278.689 186.955 278.469 186.651 278.331C186.097 278.037 185.497 277.838 184.877 277.742L182.973 277.448L185.085 272.843L186.989 273.137C188.218 273.328 190.166 273.232 191.265 272.09C191.762 271.529 192.291 270.997 192.849 270.497C194 269.363 193.152 268.342 192.252 267.823L190.858 267.018L196.666 263.642L198.06 264.447C198.765 264.818 199.54 265.039 200.335 265.098C201.131 265.156 201.929 265.049 202.682 264.785C203.547 264.447 204.491 264.144 205.426 263.858C207.408 263.218 207.555 262.084 207.217 261.374L206.707 260.275L214.653 259.037L215.163 260.145C215.398 260.577 215.752 260.932 216.185 261.166C217.018 261.606 217.953 261.815 218.894 261.772C219.95 261.772 221.006 261.772 222.062 261.772C224.338 261.772 225.446 260.855 225.767 260.145L226.269 259.037L234.232 260.275L233.73 261.374C233.461 261.954 233.522 262.82 234.647 263.469C234.92 263.631 235.21 263.762 235.513 263.858C236.448 264.144 237.374 264.447 238.265 264.785C239.017 265.052 239.816 265.16 240.612 265.102C241.408 265.044 242.183 264.821 242.888 264.447L244.281 263.642L250.124 267.018L248.799 267.866C247.934 268.385 247.068 269.407 248.245 270.541C248.804 271.043 249.336 271.575 249.838 272.133C250.035 272.34 250.263 272.515 250.513 272.653C251.632 273.21 252.9 273.395 254.131 273.181L256.027 272.886L258.191 277.491L256.287 277.785C255.057 277.984 253.447 278.651 253.491 279.941C253.538 280.551 253.538 281.165 253.491 281.776C253.505 282.109 253.612 282.431 253.798 282.708C253.984 282.984 254.243 283.204 254.547 283.342C255.101 283.637 255.701 283.836 256.321 283.931L258.217 284.225L256.113 288.83L254.209 288.536C252.98 288.345 251.024 288.432 249.925 289.583C249.43 290.144 248.905 290.676 248.349 291.176C247.181 292.266 248.029 293.288 248.938 293.833ZM209.987 286.969C215.882 290.371 225.394 290.362 231.246 286.969C237.097 283.576 237.062 278.054 231.176 274.652C225.29 271.25 215.778 271.25 209.918 274.652C204.058 278.054 204.101 283.567 209.987 286.969Z",
    fill: "#D3E5E4"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M214.92 302.583L214.885 312.519L206.922 311.29L206.948 301.354L214.92 302.583Z",
    fill: "#D3E5E4"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M235.437 272.945C227.153 268.167 213.798 268.159 205.523 272.945C201.602 275.23 199.559 278.182 199.395 281.168C199.55 284.189 201.628 287.184 205.618 289.495C213.91 294.273 227.301 294.273 235.532 289.495C239.462 287.218 241.496 284.301 241.669 281.281C241.505 278.251 239.436 275.256 235.437 272.945ZM231.109 286.941C225.301 290.308 215.849 290.317 210.006 286.941C207.237 285.34 205.774 283.271 205.618 281.185C205.782 279.117 207.219 277.074 209.946 275.499C215.754 272.123 225.206 272.123 231.048 275.499C233.818 277.1 235.281 279.16 235.437 281.255C235.272 283.323 233.836 285.357 231.118 286.907L231.109 286.941Z",
    fill: "#EAF5F4"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M205.521 272.946C213.761 268.159 227.161 268.168 235.435 272.946C239.426 275.257 241.494 278.243 241.668 281.264C241.858 277.983 239.781 274.66 235.435 272.15C227.152 267.363 213.796 267.363 205.521 272.15C201.254 274.634 199.22 277.914 199.393 281.16C199.566 278.174 201.6 275.222 205.521 272.946Z",
    fill: "url(#paint14_linear_3195_2978)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M182.469 185.781C182.469 191.165 186.286 197.787 190.96 200.496L265.875 243.774C270.549 246.466 274.366 244.259 274.366 238.875V63.0862C274.366 57.7024 270.549 51.0808 265.875 48.3715L190.96 5.09295C186.286 2.39236 182.469 4.59957 182.469 9.98343V185.781Z",
    fill: "#F2F2F2"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M184.816 4.66725C186.366 3.65453 188.564 3.71512 190.997 5.126L265.912 48.4046C270.586 51.0965 274.403 57.7181 274.403 63.1193V238.839C274.403 241.496 273.468 243.375 271.962 244.283L278.021 240.345C279.579 239.479 280.549 237.558 280.549 234.849V59.1377C280.549 53.7452 276.723 47.1322 272.057 44.4229L197.133 1.14437C194.701 -0.257854 192.503 -0.327104 190.953 0.694271L184.816 4.66725Z",
    fill: "#00ABAB"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M187.828 16.3154V178.437L269.071 225.342V63.2294L187.828 16.3154Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M228.45 204.927C225.091 202.996 222.391 204.563 222.391 208.441C222.502 210.548 223.109 212.599 224.162 214.428C225.215 216.256 226.684 217.811 228.45 218.966C231.808 220.905 234.509 219.338 234.509 215.461C234.396 213.352 233.789 211.3 232.737 209.47C231.684 207.64 230.215 206.084 228.45 204.927ZM228.45 216.915C227.194 216.101 226.148 215.003 225.396 213.71C224.644 212.417 224.208 210.964 224.122 209.471C224.122 206.727 226.043 205.619 228.45 206.987C229.705 207.8 230.751 208.898 231.503 210.191C232.255 211.485 232.692 212.937 232.777 214.43C232.752 217.174 230.83 218.282 228.45 216.915Z",
    fill: "#D3E5E4"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M238.136 39.9551L218.773 28.7805V26.6426L238.136 37.8258V39.9551Z",
    fill: "#D3E5E4"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M250.383 163.595V87.3555C250.3 85.8341 249.86 84.3536 249.099 83.0335C248.338 81.7134 247.278 80.5906 246.003 79.7558L179.874 41.5494C179.433 41.2341 178.918 41.0395 178.379 40.9848C177.84 40.9302 177.296 41.0174 176.801 41.2378L179.095 39.9135C179.595 39.6541 180.157 39.5402 180.719 39.5846C181.28 39.6289 181.818 39.8299 182.271 40.1645L248.444 78.3622C249.72 79.1966 250.782 80.3191 251.544 81.6391C252.306 82.9592 252.748 84.4399 252.833 85.9619V162.201C252.896 162.767 252.797 163.338 252.549 163.85C252.301 164.361 251.913 164.792 251.43 165.092L249.24 166.356C249.644 166.026 249.959 165.601 250.159 165.119C250.358 164.637 250.435 164.114 250.383 163.595Z",
    fill: "#D3E5E4"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M250.382 87.3544C250.299 85.8331 249.859 84.3526 249.098 83.0325C248.338 81.7123 247.277 80.5896 246.002 79.7547L179.873 41.5484C177.458 40.1548 175.484 41.2974 175.484 44.0845V120.324C175.569 121.845 176.011 123.324 176.773 124.643C177.535 125.962 178.597 127.083 179.873 127.915L246.046 166.121C248.461 167.515 250.426 166.381 250.426 163.594L250.382 87.3544Z",
    fill: "#F2F2F2"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M181.464 63.6408L183.974 65.095V54.2321L193.383 59.6592V56.7595L181.464 49.835V63.6408ZM230.681 78.3036V81.2119L240.089 86.6391V97.4933L242.6 98.9475V85.1849L230.681 78.3036ZM183.94 108.174L181.43 106.729V120.483L183.94 121.937L193.349 127.364V124.465L183.974 118.985L183.94 108.174ZM240.055 151.453L230.681 145.991V148.891L240.089 154.318L242.6 155.772V142.01L240.089 140.564L240.055 151.453Z",
    fill: "#00ABAB"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M221.309 166.397C221.309 161.844 224.511 159.992 228.45 162.269C232.388 164.545 235.591 170.059 235.591 174.646C235.591 179.234 232.397 181.043 228.45 178.766C224.503 176.49 221.309 170.916 221.309 166.397Z",
    fill: "#E16408"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M244.793 200.131L212.117 181.27V179.271L244.793 198.14V200.131Z",
    fill: "#00ABAB"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M224.017 183.46L231.045 187.52V185.529L224.017 181.469V183.46ZM212.098 176.587L220.857 181.642V179.643L212.098 174.588V176.587ZM236.135 188.472V190.462L244.79 195.448V193.423L236.135 188.472Z",
    fill: "#00ABAB"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M234.108 162.634C233.959 162.557 233.787 162.541 233.626 162.588C233.465 162.634 233.328 162.74 233.243 162.885L228.006 172.311L225.6 168.139C225.556 168.064 225.498 167.998 225.429 167.945C225.36 167.893 225.281 167.854 225.197 167.832C225.113 167.81 225.025 167.805 224.939 167.817C224.853 167.828 224.77 167.857 224.695 167.901C224.62 167.944 224.555 168.002 224.502 168.072C224.45 168.141 224.411 168.22 224.389 168.304C224.367 168.388 224.362 168.475 224.373 168.561C224.385 168.647 224.414 168.73 224.457 168.805L227.443 173.999C227.503 174.099 227.588 174.182 227.69 174.24C227.792 174.298 227.907 174.328 228.023 174.328C228.14 174.328 228.255 174.298 228.357 174.24C228.459 174.182 228.543 174.099 228.603 173.999L234.403 163.534C234.444 163.456 234.469 163.37 234.477 163.282C234.485 163.194 234.474 163.105 234.447 163.021C234.419 162.937 234.375 162.859 234.317 162.793C234.259 162.726 234.188 162.672 234.108 162.634Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M222.227 96.2362L204.102 85.7715V109.133L222.227 119.589V96.2362Z",
    fill: "#00706A"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M232.942 138.743C231.038 133.151 228.527 127.274 226.788 124.825C222.391 118.67 218.738 117.164 212.229 113.642C205.72 109.651 202.058 106.933 197.679 108.015C195.947 108.448 193.42 111.434 191.516 114.827L232.942 138.743Z",
    fill: "#CE6620"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M215.145 109.182L212.228 107.451L209.302 105.807C209.051 109.312 207.848 110.948 205.598 109.65C202.758 115.648 209.51 122.278 212.219 123.836C214.928 125.395 221.498 126.537 218.841 117.293C216.599 115.994 215.361 112.974 215.145 109.182Z",
    fill: "#F0C29B"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M218.825 86.5797C217.099 84.225 214.854 82.2997 212.264 80.9535C209.511 79.3695 207.165 78.452 205.703 79.006C202.976 80.036 202.24 86.7961 203.322 92.1886C205.599 103.761 208.118 107.821 212.264 110.219C216.41 112.616 218.929 111.456 221.205 102.515C222.287 98.3256 221.517 90.7691 218.825 86.5797Z",
    fill: "#FBD0A8"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M206.257 84.1274C205.244 87.1569 204.067 104.183 206.439 113.488C202.976 110.822 200.501 107.887 199.999 105.516C198.597 98.8941 196.891 68.5471 212.013 77.2721C227.134 85.9971 226.546 106.26 224.295 119.547C223.663 123.269 219.967 121.944 218.055 120.637C219.578 115.201 221.067 102.166 221.283 99.8635C213.069 96.7561 206.257 84.1274 206.257 84.1274Z",
    fill: "#009692"
  }))), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0728 77.7383C55.6298 72.2679 59.2911 64.3306 63.0996 57.5186V86.9913C63.0996 110.093 50.0728 137.255 32.4844 152.1C38.076 128.21 37.0719 103.177 37.0286 78.8203C41.5988 81.4776 45.2516 82.4816 50.0728 77.7383Z",
    fill: "url(#paint15_linear_3195_2978)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3711 95.4653C27.5854 92.7906 32.4153 85.5631 37.0288 78.8203C37.0721 103.177 38.0761 128.21 32.4845 152.1C16.0387 156.367 1.6875 132.65 1.6875 122.454V92.9811C6.25772 95.6124 11.6762 97.9754 19.3711 95.4653Z",
    fill: "url(#paint16_linear_3195_2978)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M1.6875 100.296C11.7974 106.649 24.1058 140.606 34.5792 141.272C34.0079 144.899 33.3328 148.508 32.4932 152.1C16.0473 156.368 1.69615 132.651 1.69615 122.455L1.6875 100.296Z",
    fill: "url(#paint17_linear_3195_2978)"
  }), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0278 78.8219L34.0156 77.0908C38.5858 79.6875 42.2385 80.7522 47.0598 76.0088C52.7064 70.2058 57.5346 63.6594 61.411 56.5508L63.1421 57.5202C59.3336 64.3323 55.6722 72.2349 50.1152 77.74C45.2507 82.4833 41.598 81.4792 37.0278 78.8219Z",
    fill: "url(#paint18_linear_3195_2978)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3498 93.726C24.5727 91.0514 29.394 83.8239 34.0161 77.0811L37.0283 78.8122C32.4148 85.555 27.5849 92.7825 19.3707 95.4571C11.6757 97.9673 6.25724 95.6043 1.68702 92.9729L0.0078125 91.9949C4.57803 94.6435 8.65488 96.2362 16.3498 93.726Z",
    fill: "url(#paint19_linear_3195_2978)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M1.68786 92.9807V122.453C1.68786 129.43 8.39605 142.742 17.9087 149.078C7.30543 143.954 0 129.17 0 121.475V92.0459L1.68786 92.9807Z",
    fill: "url(#paint20_linear_3195_2978)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M131.035 251.617C131.035 244.866 135.311 244.693 135.311 244.693C137.408 244.536 139.46 244.005 141.37 243.126C145.083 241.585 150.32 242.174 147.429 247.575C147.398 247.643 147.363 247.71 147.325 247.774C147.084 248.137 146.757 248.434 146.373 248.64L137.025 254.128C135.588 254.881 131.061 253.011 131.035 251.617Z",
    fill: "url(#paint21_linear_3195_2978)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M131.055 251.011C131.142 252.405 135.608 254.249 137.019 253.435L146.367 247.956C146.837 247.677 147.281 247.356 147.691 246.995C147.605 247.177 147.527 247.35 147.423 247.558C147.392 247.626 147.357 247.692 147.319 247.757C147.078 248.119 146.751 248.416 146.367 248.622L137.019 254.11C135.686 254.872 131.626 253.245 131.09 251.92C131.083 251.828 131.083 251.735 131.09 251.643C131.064 251.434 131.052 251.223 131.055 251.011Z",
    fill: "#355A57"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M133.841 243.191C135.384 243.411 136.902 243.773 138.377 244.273C138.408 244.665 138.536 245.043 138.749 245.373C138.799 245.414 138.84 245.463 138.87 245.52C139.736 246.091 140.602 247.017 138.576 248.255C138.048 248.645 137.398 248.834 136.742 248.788C136.087 248.742 135.47 248.464 135.001 248.004C134.746 247.47 134.348 247.018 133.85 246.697C133.517 246.466 133.14 246.307 132.742 246.23V246.126C132.742 246.126 133.339 243.191 133.841 243.191Z",
    fill: "#F8CEA6"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M133.571 172.904C138.193 172.991 146.442 173.874 151.064 173.96C149.333 187.809 148.468 197.928 146.148 211.37C143.672 224.44 140.877 233.624 138.436 244.496C137.57 246.53 134.047 245.976 133.242 244.028C134.169 231.374 132.091 221.593 135.06 210.037C134.792 203.485 135.813 195.522 134.766 192.553C132.546 186.242 132.133 179.437 133.571 172.904Z",
    fill: "#F2F2F2"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M144.637 259.472C144.637 252.72 148.913 252.547 148.913 252.547C151.01 252.39 153.061 251.86 154.972 250.981C158.685 249.44 163.922 250.037 161.031 255.438C161.001 255.504 160.966 255.568 160.927 255.629C160.694 255.996 160.369 256.294 159.983 256.494L150.626 261.982C149.198 262.744 144.663 260.865 144.637 259.472Z",
    fill: "url(#paint22_linear_3195_2978)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M144.662 258.863C144.74 260.257 149.206 262.1 150.617 261.287L159.965 255.807C160.431 255.526 160.871 255.205 161.281 254.847C161.194 255.028 161.116 255.21 161.013 255.418C160.983 255.484 160.948 255.548 160.909 255.608C160.676 255.975 160.351 256.274 159.965 256.474L150.608 261.962C149.275 262.723 145.216 261.096 144.688 259.772C144.663 259.684 144.649 259.594 144.645 259.503C144.636 259.29 144.642 259.076 144.662 258.863Z",
    fill: "#355A57"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M147.049 251.042C148.716 251.272 150.363 251.634 151.974 252.124C152.006 252.517 152.137 252.895 152.355 253.223C152.355 253.267 152.433 253.318 152.476 253.37C153.341 253.95 154.155 254.868 152.173 256.114C151.643 256.502 150.993 256.688 150.338 256.641C149.683 256.593 149.067 256.314 148.598 255.855C148.34 255.322 147.942 254.871 147.447 254.548C147.117 254.317 146.742 254.158 146.348 254.08V253.985C146.348 253.985 146.547 251.042 147.049 251.042Z",
    fill: "#F8CEA6"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M139.788 179.697C144.41 179.784 155.316 180.883 159.938 180.961C162.864 197.303 162.059 205.777 159.748 219.228C157.272 232.289 154.476 241.473 152.035 252.353C151.17 254.379 147.344 253.608 146.522 251.661C147.128 240.408 145.656 229.442 148.634 217.904C148.097 211.092 147.076 200.912 146.228 198.619C144.6 194.239 138.948 189.097 139.788 179.697Z",
    fill: "#F2F2F2"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M135.193 132.182C132.544 134.735 129.203 142.62 128.355 151.155C127.688 157.803 128.536 164.848 132.388 170.085C137.383 163.515 135.193 132.182 135.193 132.182Z",
    fill: "#E16408"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M150.081 131.018C146.671 128.334 144.827 126.811 143.156 126.473C129.671 123.712 131.402 147.55 132.527 173.266C133.575 180.104 135.037 180.823 137.53 182.294C143.589 185.523 157.213 188.353 160.745 181.498C158.269 175.387 156.149 166.298 155.984 159.642C155.88 155.418 158.823 152.06 159.81 147.325C159.689 146.2 156.097 138.392 155.794 137.475C154.772 135.138 151.224 131.918 150.081 131.018Z",
    fill: "url(#paint23_linear_3195_2978)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M155.68 116.069C154.589 111.984 150.486 105.371 143.103 106.963C135.979 108.504 134.292 113.118 134.447 120.311C134.551 124.889 132.604 124.396 131.773 127.59C131.262 129.529 132.734 132.178 131.227 134.93C130.412 136.527 129.029 137.762 127.35 138.392C121.957 140.643 125.489 143.291 128.665 143.984C136.386 145.715 133.201 142.036 136.516 141.387C138.464 140.989 142.021 142.85 143.847 141.915C147.431 140.072 146.124 138.081 147.803 136.237C149.482 134.393 151.542 134.714 153.957 131.788C154.953 130.717 155.594 129.367 155.796 127.919C155.997 126.471 155.748 124.996 155.083 123.695C154.139 121.453 156.502 119.246 155.68 116.069Z",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M153.603 162.127C155.464 165.753 157.472 179.802 157.299 184.631C158.779 184.022 160.003 182.917 160.761 181.507C158.285 175.396 156.165 166.307 156 159.651C155.896 155.427 158.839 152.069 159.826 147.334C159.71 146.297 159.484 145.276 159.151 144.287C157.03 146.408 155.187 148.269 154.555 150.13C153.923 151.991 151.733 158.508 153.603 162.127Z",
    fill: "url(#paint24_linear_3195_2978)"
  }), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M161.567 134.396C162.432 135.651 163.566 134.664 162.372 133.236C161.177 131.808 160.087 132.284 161.567 134.396Z",
    fill: "#F8CEA6"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M161.47 136.168C162.673 137.103 163.452 135.83 161.885 134.826C160.319 133.822 159.427 134.567 161.47 136.168Z",
    fill: "#F8CEA6"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M161.02 137.035C162.128 137.398 162.362 136.291 160.977 135.962C159.592 135.633 159.15 136.429 161.02 137.035Z",
    fill: "#F8CEA6"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M164.294 142.729C164.294 141.56 163.238 140.461 162.926 139.794C162.1 139.126 161.233 138.51 160.329 137.951C159.732 137.544 163.792 137.951 164.432 136.938C164.432 136.938 167.964 136.341 168.665 137.882C169.444 139.881 168.665 141.024 168.665 142.209C168.717 142.218 164.294 143.897 164.294 142.729Z",
    fill: "#F8CEA6"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M165.618 140.054L160 137.717L164.648 127.33L170.274 129.667L165.618 140.054Z",
    fill: "#6AB4AD"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M160.492 137.563L164.855 127.825L169.762 129.868L165.4 139.606L160.492 137.563Z",
    fill: "#66B2AB"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M165.825 140.465L165.617 140.058L170.274 129.671L170.473 130.078L165.825 140.465Z",
    fill: "#49A39B"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M160.199 138.117L160 137.719L165.618 140.056L165.825 140.463L160.199 138.117Z",
    fill: "#6AB4AD"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M169.306 137.579C169.281 137.359 169.207 137.147 169.091 136.958C168.974 136.77 168.817 136.609 168.63 136.489C168.63 135.121 168.717 133.347 168.717 133.347C167.99 133.182 167.514 133.918 167.436 134.325C167.323 134.931 167.514 136.246 166.977 136.826C165.957 137.772 165.337 139.073 165.246 140.462L166.302 141.206L168.336 139.7L168.985 140.193C168.985 140.193 169.262 138.03 169.306 137.579Z",
    fill: "#F8CEA6"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M149.163 143.372C150.202 148.912 157.351 160.615 162.899 163.402C168.231 163.887 168.777 148.427 169.045 142.109L163.912 142.455C163.332 146.16 163.228 149.691 162.666 152.123C160.51 147.596 159.056 143.121 156.295 138.041C154.555 133.366 147.639 135.262 149.163 143.372Z",
    fill: "url(#paint25_linear_3195_2978)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M99.035 216.07V250.208C99.035 271.848 83.8182 298.239 65.0527 309.067C46.2871 319.896 31.0703 311.145 31.0703 289.453V255.315L99.035 216.07Z",
    fill: "#D3E5E4"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9057 262.144C44.5849 259.236 44.5849 256.085 42.9057 255.124C41.2265 254.164 38.5086 255.722 36.8467 258.63C35.1848 261.538 35.1675 264.689 36.8467 265.65C38.5259 266.611 41.2265 265.044 42.9057 262.144Z",
    fill: "#F2F2F2"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7708 258.049L36.793 259.743L41.9658 262.728L42.9436 261.034L37.7708 258.049Z",
    fill: "#D3E5E4"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M87.206 229.545C88.8853 226.637 91.6118 225.062 93.265 226.031C94.9183 227.001 94.9529 230.143 93.265 233.051C91.5772 235.959 88.8679 237.526 87.206 236.556C85.5442 235.587 85.5268 232.454 87.206 229.545Z",
    fill: "#F2F2F2"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M88.1536 228.964L87.1758 230.658L92.3486 233.644L93.3264 231.949L88.1536 228.964Z",
    fill: "#D3E5E4"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3436 203.549L9.37891 242.794L31.0701 255.319L99.0348 216.074L77.3436 203.549Z",
    fill: "#F2F2F2"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0718 255.314V289.453C31.0718 300.229 34.8371 307.811 40.922 311.386L19.8107 299.19C13.3709 295.728 9.36328 288.05 9.36328 276.928V242.764L31.0718 255.314Z",
    fill: "#D3E5E4"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M31.5234 245.95H47.2942L52.7646 242.791L58.2523 239.623H31.5234V245.95Z",
    fill: "url(#paint26_linear_3195_2978)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M76.8945 219.759H92.6566L99.0359 216.072L94.457 213.432H76.8945V219.759Z",
    fill: "url(#paint27_linear_3195_2978)"
  }), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M57.179 180.343C71.3397 172.163 82.8259 178.793 82.8259 195.152V216.333L76.8967 219.795V198.571C76.8967 186.012 68.0506 180.905 57.179 187.189C46.3074 193.473 37.4526 208.829 37.4526 221.353V242.525L31.5234 245.987V224.772C31.5234 208.413 43.0096 188.522 57.179 180.343Z",
    fill: "#009692"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M76.8689 198.571V219.76L70.9397 216.298V195.161C70.9397 190.625 69.7712 187.076 67.7891 184.661C73.2681 185.561 76.8689 190.538 76.8689 198.571Z",
    fill: "#00706A"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2474 176.914C58.3018 172.845 64.6897 172.447 69.3292 175.096L75.1977 178.48C70.5583 175.832 64.1704 176.23 57.116 180.307C42.9466 188.486 31.4604 208.377 31.4604 224.736V245.917L25.5312 242.455V221.352C25.5918 204.993 37.052 185.093 51.2474 176.914Z",
    fill: "#00ABAB"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8017 288.53L63.1836 286.435V281.787L66.8017 283.882V288.53Z",
    fill: "url(#paint28_linear_3195_2978)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9926 289.578L63.1836 290.625V286.436L66.8017 288.53L64.9926 289.578Z",
    fill: "url(#paint29_linear_3195_2978)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M64.994 255.558C68.0841 253.766 70.5856 255.22 70.5856 258.786C70.4104 261.925 69.06 264.882 66.803 267.07L59.7227 262.984C60.4817 259.933 62.3642 257.281 64.994 255.558Z",
    fill: "url(#paint30_linear_3195_2978)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7031 267.155L63.1654 269.163C62.4411 269.333 61.6791 269.22 61.0355 268.847C60.3919 268.474 59.9153 267.868 59.7031 267.155Z",
    fill: "url(#paint31_linear_3195_2978)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1837 269.165L59.7214 267.156C59.5125 266.541 59.41 265.894 59.4185 265.244C59.4343 264.48 59.5418 263.722 59.7387 262.984L66.8191 267.07V280.053L63.201 277.959L63.1837 269.165Z",
    fill: "url(#paint32_linear_3195_2978)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8017 280.083C67.6673 279.555 68.4463 279.988 68.4463 281.035C68.4145 281.605 68.2491 282.16 67.9635 282.655C67.6778 283.15 67.2798 283.57 66.8017 283.883L63.1836 281.788V277.988L66.8017 280.083Z",
    fill: "url(#paint33_linear_3195_2978)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3195_2978",
    x1: 185.164,
    y1: 290.748,
    x2: 269.159,
    y2: 290.748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4E1DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FFFFFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3195_2978",
    x1: 205.608,
    y1: 278.981,
    x2: 235.453,
    y2: 278.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#B6DAD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#9CCDC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92C8C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3195_2978",
    x1: 233.591,
    y1: 266.092,
    x2: 234.249,
    y2: 266.092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#B6DAD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#9CCDC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92C8C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3195_2978",
    x1: 206.69,
    y1: 266.101,
    x2: 207.374,
    y2: 266.101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#B6DAD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#9CCDC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92C8C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3195_2978",
    x1: 244.366,
    y1: 276.959,
    x2: 250.062,
    y2: 271.826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#B6DAD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#9CCDC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92C8C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3195_2978",
    x1: 241.805,
    y1: 287.573,
    x2: 257.203,
    y2: 283.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#B6DAD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#9CCDC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92C8C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3195_2978",
    x1: 256.07,
    y1: 291.453,
    x2: 258.208,
    y2: 291.453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#B6DAD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#9CCDC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92C8C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3195_2978",
    x1: 237.122,
    y1: 299.434,
    x2: 254.78,
    y2: 293.748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#B6DAD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#9CCDC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92C8C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_3195_2978",
    x1: 185.162,
    y1: 295.311,
    x2: 193.549,
    y2: 295.311,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#B6DAD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#9CCDC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92C8C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_3195_2978",
    x1: 244.496,
    y1: 301.268,
    x2: 250.33,
    y2: 301.268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#B6DAD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#9CCDC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92C8C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_3195_2978",
    x1: 225.411,
    y1: 303.051,
    x2: 252.347,
    y2: 303.051,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#B6DAD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#9CCDC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92C8C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_3195_2978",
    x1: 196.849,
    y1: 303.061,
    x2: 207.591,
    y2: 303.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#B6DAD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#9CCDC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92C8C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_3195_2978",
    x1: 226.504,
    y1: 306.936,
    x2: 234.484,
    y2: 306.936,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#B6DAD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#9CCDC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92C8C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_3195_2978",
    x1: 214.887,
    y1: 306.183,
    x2: 226.529,
    y2: 306.183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#B6DAD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#9CCDC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92C8C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_3195_2978",
    x1: 199.384,
    y1: 274.911,
    x2: 241.676,
    y2: 274.911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#B6DAD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#9CCDC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#92C8C3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_3195_2978",
    x1: 112.584,
    y1: 72.0515,
    x2: 48.6965,
    y2: 104.346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF7320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4914E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_3195_2978",
    x1: 1.98179,
    y1: 139.237,
    x2: 41.3393,
    y2: 95.7163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF7320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#EB6E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E16408"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_3195_2978",
    x1: 34.5706,
    y1: 126.445,
    x2: 1.6875,
    y2: 126.445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9DEF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_3195_2978",
    x1: 56.5291,
    y1: 53.729,
    x2: 40.793,
    y2: 80.9945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#E16408"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF7320"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_3195_2978",
    x1: 26.0009,
    y1: 72.4502,
    x2: 11.0352,
    y2: 98.3741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF7320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#EB6E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E16408"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_3195_2978",
    x1: 8.95866,
    y1: 149.078,
    x2: 8.95866,
    y2: 92.0026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF7320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#EB6E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E16408"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_3195_2978",
    x1: 148.269,
    y1: 248.32,
    x2: 131.027,
    y2: 248.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E16408"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E66911"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF7320"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_3195_2978",
    x1: 161.87,
    y1: 256.174,
    x2: 144.637,
    y2: 256.174,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E16408"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E66911"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF7320"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_3195_2978",
    x1: 131.774,
    y1: 155.981,
    x2: 176.507,
    y2: 155.981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF7320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#EB6E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#E16408"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_3195_2978",
    x1: 156.797,
    y1: 184.623,
    x2: 156.797,
    y2: 122.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E2E5F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D6EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_3195_2978",
    x1: 169.036,
    y1: 149.475,
    x2: 148.938,
    y2: 149.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E16408"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EF7320"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_3195_2978",
    x1: 31.5234,
    y1: 242.782,
    x2: 58.2523,
    y2: 242.782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3E5E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#D5E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#F4F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_3195_2978",
    x1: 76.8945,
    y1: 216.591,
    x2: 99.0359,
    y2: 216.591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3E5E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#D5E6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#F4F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_3195_2978",
    x1: 66.8103,
    y1: 285.163,
    x2: 63.1836,
    y2: 285.163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00ABAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#009E9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_3195_2978",
    x1: 66.8103,
    y1: 288.53,
    x2: 63.1836,
    y2: 288.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00ABAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#009E9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_3195_2978",
    x1: 70.5942,
    y1: 260.933,
    x2: 59.7227,
    y2: 260.933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00ABAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#009E9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_3195_2978",
    x1: 63.1827,
    y1: 268.194,
    x2: 59.7031,
    y2: 268.194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00ABAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#009E9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_3195_2978",
    x1: 66.8104,
    y1: 271.536,
    x2: 59.4011,
    y2: 271.536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00ABAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#009E9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009692"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_3195_2978",
    x1: 68.4549,
    y1: 280.94,
    x2: 63.1836,
    y2: 280.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00ABAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#009E9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009692"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceMatch);
export default __webpack_public_path__ + "static/media/face-match.760f37e06d812a72d8070163b2a5d62a.svg";
export { ForwardRef as ReactComponent };